// removed by extract-text-webpack-plugin
module.exports = {"changelog-wrap":"changelog-wrap___WAx_O","changelog-item":"changelog-item___IR8tR","changelog-title":"changelog-title___1kq6B h2___hzLuT","changelog-info":"changelog-info___3V-1P h4___kHWTn","changelog-item-title":"changelog-item-title___3bc0Y h3___5u0xZ","changelog-item-content":"changelog-item-content___1ZjVF","changelog-item-links":"changelog-item-links___2Motl center___2iqBf","changelog-item-link":"changelog-item-link___2zG0K","changelog-open-button":"changelog-open-button___2DzHW h3___5u0xZ"};


//////////////////
// WEBPACK FOOTER
// ./src/core/Changelog/Changelog.css
// module id = 906
// module chunks = 0